import { createAction, props } from "@ngrx/store";
import { HomeLobbyComponent } from "./homeLobby.state";

export const activateHomeLobbyComponent = createAction(
    "[HOME-LOBBY] ACTIVATE LOBBY COMPONENT",
    props<{
        component: HomeLobbyComponent;
    }>()
);
